import { JsonObject, JsonProperty } from 'json2typescript';
import { DocumentDataInterface } from '../interfaces/document-data.interface';

@JsonObject('DocumentData')
export class DocumentData implements DocumentDataInterface {
  CategoryId?: string;
  CategoryName?: string;
  ClientId?: string;
  Description?: string;
  ElementCode?: string;
  ElementType?: string;
  ElementName?: string;
  ExpirationDate?: string;
  FileName?: string;
  FileType?: string;
  Id?: string;
  LastDate?: string;
  ModuleId?: string;
  ModuleName?: string;
  Name?: string;
  RealFileName?: string;
  UploadType?: string;
  ValidationStatus?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
